//import history from './history';

export const makeRelativeRedirect = (history,url) => {
    return () => {
        history.push(url)
    }
}

export const makeAbsoluteRedirect = (url) => {
    return () => {
        window.location.replace( url )
    }
}


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/Utils/RedirectUtils.js